import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('pricing');

export class CommunityBenefitBilling extends Api {
  constructor(http, config = {}) {
    super(http, url, 'community-benefit-billing', config);
  }
}
